import { Injectable } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class FuseProgressBarService
{
  private _visible: BehaviorSubject<boolean>;
    private _showLoader: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public showLoaderEmitter: Observable<boolean> = this._showLoader.asObservable();
    constructor( private _router: Router) { 
      this._init();
    }
    
    get visible(): Observable<any>
    {
        return this._visible.asObservable();
    }
    private _init(): void
    {
        // Initialize the behavior subjects
       
        this._visible = new BehaviorSubject(false);

        // Subscribe to the router events to show/hide the loading bar
        this._router.events
            .pipe(filter((event) => event instanceof NavigationStart))
            .subscribe(() => {
                this.open();
            });

        this._router.events
            .pipe(filter((event) => event instanceof NavigationEnd || event instanceof NavigationError || event instanceof NavigationCancel))
            .subscribe(() => {
                this.close();
            });
    }
  public open() {
	  this._showLoader.next(true);
    this._visible = new BehaviorSubject(true);

  }

  public close() {
	  this._showLoader.next(false);
    this._visible = new BehaviorSubject(false);

  }
}

